import { AsyncActionCreators } from 'typescript-fsa'
import { Dispatch } from 'redux'

// https://github.com/aikoven/typescript-fsa/issues/5#issuecomment-255347353
function wrapAsyncWorker<P, S, E>(
	asyncAction: AsyncActionCreators<P, S, E>,
	worker: (params: P) => Promise<S>,
) {
	return (dispatch: Dispatch<void>, params: P): Promise<void> => {
		dispatch(asyncAction.started(params))
		return worker(params)
			.then((result: S) => {
				dispatch(asyncAction.done({ params, result }))
			})
			.catch((error: E) => {
				dispatch(asyncAction.failed({ params, error }))
			})
	}
}

export default wrapAsyncWorker


// WEBPACK FOOTER //
// ./src/wrapAsyncWorker.ts